<template>
  <p :class="textClass">
    <slot />
  </p>
</template>

<script setup>
import { computed } from 'vue'

/**
 * ContentText - テキスト表示コンポーネント (Atom)
 *
 * アプリケーション全体で使用される再利用可能な基本テキストコンポーネントです。
 *
 * 責務:
 * - テキストの統一された表示
 * - サイズ・色・スタイルのバリエーション提供
 * - UIの描画に専念（ロジックは持たない）
 */

const props = defineProps({
  /**
   * テキストのサイズ
   * 'sm': 小サイズ
   * 'md': 標準サイズ
   * 'lg': 大サイズ
   */
  size: {
    type: String,
    default: 'md',
    validator: (value) => {
      return ['sm', 'md', 'lg'].includes(value)
    }
  },
  /**
   * テキストの色
   * 'default': 標準色
   * 'muted': 薄い色
   * 'emphasis': 強調色
   * 'primary': プライマリー色
   */
  color: {
    type: String,
    default: 'default',
    validator: (value) => {
      return ['default', 'muted', 'emphasis', 'primary'].includes(value)
    }
  }
})

const textClass = computed(() => {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  }

  const colorClasses = {
    default: 'text-gray-900',
    muted: 'text-gray-600',
    emphasis: 'text-gray-800',
    primary: 'text-primary'
  }

  return [
    sizeClasses[props.size],
    colorClasses[props.color],
    'leading-relaxed'
  ]
})
</script>

<style scoped>
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-gray-900 {
  color: #111827;
}

.text-gray-800 {
  color: #1f2937;
}

.text-gray-600 {
  color: #4b5563;
}

.text-primary {
  color: #0d6efd;
}

.leading-relaxed {
  line-height: 1.625;
}
</style>
